const BASE_URL = "https://sdk.richmob.cn"; //接口地址
// const BASE_URL = "http://119.45.48.13"; //测试接口地址
// const BASE_URL = "http://sdktest.richmob.cn"; //测试环境接口地址
// const BASE_URL = "http://192.168.1.147:8090"; //接口地址

const common = {
	uploadImg: BASE_URL + '/common/upload' // 上传图片
}; //公共模块
const loginSDK = BASE_URL + '/Sapi/admin/login'; //登录
const mediaRegisterSDK = BASE_URL + '/sona/admin/register'; //注册
const sendCode =  BASE_URL + '/sona/admin/sendCode'; //发送邮箱验证码
const forgetPwd =  BASE_URL + '/sona/admin/retrieve'; //忘记密码

const mediaLoginSDK = BASE_URL + '/sona/admin/login'; //登录
const loginSDK2 = BASE_URL + '/SAapi/media/login'; //SDK登录错误
const loginAPI = BASE_URL + '/Aapi/media/login'; //登录
export default {
    common,
    loginSDK,
		mediaRegisterSDK,
		sendCode,
		forgetPwd,
		mediaLoginSDK,
		loginSDK2,
    loginAPI, //
}